export enum PersonalCompanyFormType {
  Personal = 'personal',
  Company = 'company'
}
